import DOMPurify, { Config } from 'dompurify';

/**
 * Nettoyage du HTML tiré d'un contenu généré, avant qu'il n'entre dans la page.
 *
 * `marked` restitue tel quel le HTML présent dans une réponse. Un document ou une
 * page web piégés peuvent en faire écrire au modèle : laissé actif, il s'exécuterait
 * dans la session de l'utilisateur, à portée des jetons du stockage navigateur.
 */

/**
 * Une réponse n'a besoin que de mise en forme. Sont écartés, en plus de ce qui
 * s'exécute : les styles libres (habiller ou masquer l'interface), les champs
 * de saisie (faux écran de connexion) et les dessins SVG ou MathML.
 */
const GENERATED_HTML: Config = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'form', 'input', 'button', 'select', 'textarea'],
  FORBID_ATTR: ['style'],
  ALLOW_DATA_ATTR: false,
};

/** Un aperçu est un document entier : sa mise en page, styles compris, est conservée. */
const PREVIEW_DOCUMENT: Config = {
  WHOLE_DOCUMENT: true,
};

/** HTML d'une réponse du modèle, une fois le markdown rendu. */
export function sanitizeGeneratedHtml(html: string): string {
  return DOMPurify.sanitize(html, GENERATED_HTML);
}

/** Document d'aperçu rendu par le serveur à partir d'un fichier décrit par le modèle. */
export function sanitizePreviewDocument(html: string): string {
  return DOMPurify.sanitize(html, PREVIEW_DOCUMENT);
}
